import { styled } from '@mui/material/styles';
import { ListItemButton } from '@mui/material';
import { AppTheme } from '../theme';


export const createFullLayoutStyles = (theme: AppTheme) => {
    return {
        logo: {
            m: '24px auto 0 auto',
            height: '76.65px',
            width:'100%',
            maxWidth:164,
            backgroundImage: `url(/assets/images/${theme.applogo})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            cursor:"pointer"
        },
        logoTablet: {
            height: "37.69px",
            width: '100%',
            maxWidth: "39.15px",
            m: '20px auto 0 auto',
            backgroundImage: `url(/assets/images/${theme.applogoTablet})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            cursor: "pointer"
        },
        menu: {
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "100%",
            width: "Fixed (240px)px",
            height: "Hug (48px)px",
            padding: "8px",
            borderRadius: "8px 0px 0px 0px",
            opacity: "0px"
        },
        gridContainer: {
            height: "100vh",
            maxWidth: "unset",
            padding: 0,
            width: "100%",
            display: "flex"
        },
        leftPanel: {
            height: "100vh",
            backgroundColor: theme.palette.neutral_5,
            backgroundSize: "contain",
            boxShadow: `0px 1px 3px 0px ${theme.palette.neutral_3}`,
            display: {
                xs: "none",
                sm: "flex",
                md: "flex",
                lg: "flex"
            },
            maxWidth: "256px !important",
            minWidth: "auto !important",
            flexDirection: "column",
            zIndex: 1,
            overflow: "auto"
        },
        leftPanelMobile: {
            height: "100vh",
            backgroundColor: theme.palette.neutral_5,
            backgroundSize: "contain",
            boxShadow: `0px 1px 3px 0px ${theme.palette.neutral_3}`,
            display: {
                xs: "flex",
                sm: "none",
                md: "none",
                lg: "none"
            },
            maxWidth: "256px",
            position: "absolute",
            flexDirection: "column",
            justifyContent: "space-between",
            zIndex: 999,
        },
        rightPanel: {
            backgroundColor: theme.palette.layoutBackground,
            maxHeight: "100vh",
            overflowY: "hidden",
            maxWidth: {
                xs: "100%",
                sm: "100%",
                md: "100%",
            },
            width: "100% !important"
        },
        header: {
            height: {
                xs: "90px",
                sm: "59px",
                lg: "90px",
            },
            width: "100%",
            display: "flex",
            position: "relative",
            justifyContent: "space-between",
            padding: "0 10px 0 30px",
            boxShadow: `0px 0.56px 1.13px 0px ${theme.palette.neutral_3}`,
            backgroundColor: theme.palette.neutral_5,
        },
        main: {
            flexGrow: 1,
            height: {
                xs: 'calc(100vh - 90px)',
                lg: 'calc(100vh - 90px)',
                sm: 'calc(100vh - 59px)',
            },
            overflow: 'auto',
            backgroundColor: theme.palette.layoutBackground,
        },
        content: {
            maxWidth: "1280px",
            pb: "80px",
            paddingLeft: "16px !important",
            paddingRight: "16px !important",
            mt: {
                xs: '5px', sm: '5px', md: '20px'
            }
        }
    }
};



export const LeftMenuItemButton = styled(ListItemButton)(({ theme }) => ({
    borderRadius: "8px",
    "&.Mui-selected": {
        backgroundColor: (theme as AppTheme).palette.primary.main,
        color: (theme as AppTheme).palette.neutral_5,
        borderRadius: "8px",
    },
    "&.Mui-selected:hover": {
        backgroundColor: (theme as AppTheme).palette.primary.dark,
        color: (theme as AppTheme).palette.neutral_5,
        borderRadius: "8px",
    },
    "&.Mui-focusVisible": {
        backgroundColor: (theme as AppTheme).palette.primary.light,
        color: (theme as AppTheme).palette.neutral_5,
        borderRadius: "8px",
    },
    ":hover": {
        backgroundColor: (theme as AppTheme).palette.primary.light,
        color: (theme as AppTheme).palette.neutral_5,
        borderRadius: "8px",
    }
}));

